import { render } from "./TileVidget.vue?vue&type=template&id=0d324bef&scoped=true"
import script from "./TileVidget.vue?vue&type=script&lang=js"
export * from "./TileVidget.vue?vue&type=script&lang=js"

import "@/assets/widget.css?vue&type=style&index=0&id=0d324bef&scoped=true&lang=css&external"
import "./TileVidget.vue?vue&type=style&index=1&id=0d324bef&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d324bef"]])

export default __exports__